var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700px",
    height: "700px",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tekso-pos") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Block-Icons",
    transform: "translate(-113.000000, -1633.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tekso-pos",
    transform: "translate(113.000000, 1633.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#C7DADE",
    cx: 467,
    cy: 237,
    r: 200
  }), /*#__PURE__*/React.createElement("g", {
    id: "POS-Terminal_line_43",
    transform: "translate(150.000000, 109.000000)",
    stroke: "#000000",
    strokeWidth: 23.5294118
  }, /*#__PURE__*/React.createElement("line", {
    x1: 329.411765,
    y1: 47.0243902,
    x2: 329.411765,
    y2: 482,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.2941176,
    y1: 117.560976,
    x2: 294.117647,
    y2: 117.560976,
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "70.5882353 117.560976 70.5882353 0 258.823529 0 258.823529 117.560976"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 70.5882353,
    y: 188.097561,
    width: 188.235294,
    height: 82.2926829
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.8235294,
    y1: 340.926829,
    x2: 141.176471,
    y2: 340.926829,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188.235294,
    y1: 340.926829,
    x2: 270.588235,
    y2: 340.926829,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.8235294,
    y1: 411.463415,
    x2: 141.176471,
    y2: 411.463415,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188.235294,
    y1: 411.463415,
    x2: 270.588235,
    y2: 411.463415,
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "258.823529 47.0243902 400 47.0243902 400 482 0 482 0 47.0243902 70.5882353 47.0243902"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.88221b83dacc421580ccb27a185282ae.svg";
export { ForwardRef as ReactComponent };